<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <div class="wrapper-title">
        <p class="title">Recibo</p>
        <CloseButton @click="closeModal" />
      </div>
      <div class="wrapper-receipt">
        <embed :src="receiptUrl" type="application/pdf" class="receipt" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CloseButton from "@/components/commons/controls/CloseButton.vue";

export default defineComponent({
  name: "ModalReceipt",
  props: {
    receiptUrl: {
      type: String,
      required: true,
    },
  },
  components: {
    CloseButton,
  },
  setup(props, context) {
    function closeModal() {
      context.emit("closeReceipt");
    }

    return {
      closeModal,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/sharedComponents/styles/modalReceiptStyle";
</style>
